<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null"
  [nzClosable]="false">
  <ng-template #modalContent>
    <div nz-row nzJustify="center">
      <div nz-col class="label-input body-font-size text-center">{{'R0000.R0046' | translate}}</div>
    </div>
    <div nz-row nzJustify="center">
      <nz-form-item class="pt-3">
        <nz-form-control [nzSpan]="9" class="pr-2">
          <div class="btn-wrapper" style="text-align: left;">
            <div class="btn-styles btn-blue text-center" style="cursor: pointer;" (click)="close(false)">
              <div class="txt">
                <button class="body-font-size" type="button" style="cursor: pointer;">{{'ok' | translate}}</button>
              </div>
            </div>
          </div>
        </nz-form-control>
        <nz-form-control [nzSpan]="15">
          <div class="btn-wrapper" style="text-align: right;">
            <div class="btn-styles btn-print text-center" style="cursor: pointer;" (click)="close(true)">
              <div class="txt">
                <svg-icon style="margin-right: 5px; cursor: pointer;" nz-icon src="./assets/images/icon/print-4.svg"
                  [svgStyle]="{'width.px':15,'height.px':15}">
                </svg-icon>
                <button type="button" class="body-font-size" style="cursor: pointer;">
                  {{'R0000.R0048' | translate}}
                </button>
              </div>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-template>
</nz-modal>